(() => {
  function initialize() {
    document.querySelectorAll('[data-product-bottom-bar].mobile_checkoutButtns--phitku-layout').forEach((bar) => {
      if (bar.dataset.quantityInitialized) return;
      const field = bar.querySelector('.mobileStickyForm [name="quantity"]');
      const value = bar.querySelector('[data-bottom-quantity-value]');
      const minus = bar.querySelector('[data-bottom-quantity-minus]');
      const plus = bar.querySelector('[data-bottom-quantity-plus]');
      if (!field || !value || !minus || !plus) return;
      bar.dataset.quantityInitialized = 'true';
      const section = document.getElementById(`MainProduct-${bar.dataset.sectionId}`);
      const mainQuantity = () => section?.querySelector('.quantity__input');
      const variantNode = document.getElementById(`StickyVariantData-${bar.dataset.sectionId}`);
      const variantData = variantNode ? JSON.parse(variantNode.textContent) : null;
      let selectedVariantId = variantData?.selectedVariantId;
      const money = new Intl.NumberFormat('en-IN', {
        style: 'currency', currency: variantData?.currency || 'INR',
        minimumFractionDigits: 0, maximumFractionDigits: 2
      });
      function setMoney(node, amount) {
        node.replaceChildren(...money.formatToParts(amount / 100).map((part) => {
          if (part.type !== 'currency') return document.createTextNode(part.value);
          const currency = document.createElement('span');
          currency.className = 'sticky-currency';
          currency.textContent = part.value;
          return currency;
        }));
      }
      function updatePrice(quantity) {
        if (!variantData) return;
        const variantId = bar.querySelector('.product-variant-id')?.value || selectedVariantId;
        const variant = variantData.variants.find((item) => String(item.id) === String(variantId));
        if (!variant) return;
        let row = bar.querySelector('.price-row');
        if (!row) {
          row = document.createElement('div');
          row.className = 'price-row';
          row.innerHTML = '<div class="current-price"></div><div class="right-price-sec"><span class="compare-price"><s></s></span><span class="discount-badge"></span></div>';
          bar.querySelector('.sticky-price').append(row);
        }
        // Melt Stik: each complete pair gets the offer; an extra unit stays at regular price.
        const total = variantData.pairOfferPrice
          ? Math.floor(quantity / 2) * variantData.pairOfferPrice + (quantity % 2) * variant.price
          : variant.price * quantity;
        const compareTotal = (variant.compare_at_price || 0) * quantity;
        setMoney(row.querySelector('.current-price'), total);
        const compare = row.querySelector('.compare-price');
        const badge = row.querySelector('.discount-badge');
        const discounted = compareTotal > total;
        compare.style.display = discounted ? '' : 'none';
        badge.style.display = discounted ? '' : 'none';
        if (discounted) {
          setMoney(compare.querySelector('s'), compareTotal);
          badge.textContent = `${Math.floor((compareTotal - total) * 100 / compareTotal)}% Off`;
        }
      }
      function sync(next) {
        const main = mainQuantity();
        const minimum = Number(main?.min || 1);
        const step = Number(main?.step || 1);
        const maximum = main?.max ? Number(main.max) : Infinity;
        const quantity = Math.min(maximum, minimum + Math.max(0, Math.round((next - minimum) / step)) * step);
        field.value = String(quantity);
        value.textContent = String(quantity).padStart(2, '0');
        minus.disabled = quantity <= minimum;
        plus.disabled = quantity + step > maximum;
        updatePrice(quantity);
        return quantity;
      }
      function change(direction) {
        const main = mainQuantity();
        const quantity = sync(Number(field.value) + direction * Number(main?.step || 1));
        field.dispatchEvent(new Event('change', { bubbles: true }));
        if (main) {
          main.value = String(quantity);
          main.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
      minus.addEventListener('click', () => change(-1));
      plus.addEventListener('click', () => change(1));
      section?.addEventListener('change', (event) => {
        if (event.target.matches('.quantity__input')) sync(Number(event.target.value));
      });
      if (section) new MutationObserver(() => sync(Number(mainQuantity()?.value || field.value))).observe(section, { childList: true, subtree: true });
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
          if (String(data.sectionId) !== String(bar.dataset.sectionId)) return;
          selectedVariantId = data.variant.id;
          const whatsappButton = bar.querySelector('.jk-whatsapp-atc');
          if (whatsappButton) {
            whatsappButton.disabled = !data.variant.available;
            whatsappButton.querySelector('span').textContent = data.variant.available
              ? window.variantStrings.addToCart : window.variantStrings.soldOut;
          }
          const stickyVariant = bar.querySelector('.product-variant-id');
          if (stickyVariant) stickyVariant.value = String(selectedVariantId);
          sync(Number(mainQuantity()?.value || field.value));
        });
      }
      sync(Number(mainQuantity()?.value || field.value));
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize);
  else initialize();
  document.addEventListener('shopify:section:load', initialize);
})();
